import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ApplicationSuccess = () => {
  const { state } = useLocation();
  const name = state?.name || "To Whom It May Concern";

  return (
    <>
      <Helmet>
        <title>Application Submitted | VisionBird</title>
        <meta
          name="description"
          content="Your application has been successfully submitted to VisionBird Technologies. We will review your profile and reach out to you soon."
        />
      </Helmet>

      <Navbar />

      <div className="success-page">
        <div style={{
          maxWidth: "580px",
          width: "100%",
          textAlign: "center",
          animation: "fadeInUp 0.6s ease both",
        }}>

          {/* Icon */}
          <div style={{
            width: "96px",
            height: "96px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #ff8000, #ff5a00)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 32px",
            boxShadow: "0 16px 40px rgba(255, 128, 0, 0.3)",
          }}>
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 6L9 17l-5-5"
                stroke="#fff"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Heading */}
          <h1 style={{
            fontSize: "clamp(26px, 5vw, 36px)",
            fontWeight: 800,
            color: "#111",
            margin: "0 0 14px",
            lineHeight: 1.2,
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            Application Received!
          </h1>

          {/* Message */}
          <p style={{
            fontSize: "16px",
            color: "#555",
            lineHeight: 1.8,
            margin: "0 0 10px",
            fontFamily: "'Segoe UI', sans-serif",
          }}>
            Thank you, <strong style={{ color: "#ff6600" }}>{name}</strong>. We've successfully received your application and our team will carefully review your profile.
          </p>

          {/* Divider card */}
          <div style={{
            background: "#fff",
            border: "1px solid #ffe0b2",
            borderRadius: "16px",
            padding: "24px 28px",
            marginBottom: "36px",
            textAlign: "left",
            boxShadow: "0 4px 20px rgba(255,128,0,0.08)",
          }}>
            <p style={{ margin: "0 0 6px", fontWeight: 700, fontSize: "13px", color: "#ff6600", textTransform: "uppercase", letterSpacing: "0.8px", fontFamily: "'Segoe UI', sans-serif" }}>
              What happens next?
            </p>
            {[
              { step: "01", text: "Our HR team reviews your application and resume carefully." },
              { step: "02", text: "If shortlisted, you'll receive a separate confirmation email with your interview date, time, and all relevant details." },
              { step: "03", text: "Keep an eye on your provided gmail for updates from our HR team." },
            ].map(({ step, text }) => (
              <div key={step} style={{ display: "flex", gap: "14px", alignItems: "flex-start", marginTop: "16px" }}>
                <span style={{
                  minWidth: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  background: "#fff8f0",
                  border: "1.5px solid #ffd199",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  fontWeight: 800,
                  color: "#ff6600",
                  fontFamily: "'Segoe UI', sans-serif",
                }}>
                  {step}
                </span>
                <p style={{ margin: 0, fontSize: "14px", color: "#444", lineHeight: 1.7, paddingTop: "5px", fontFamily: "'Segoe UI', sans-serif" }}>
                  {text}
                </p>
              </div>
            ))}
          </div>

          {/* Back button */}
          <Link
            to="/"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #ff8000, #ff5a00)",
              color: "#fff",
              textDecoration: "none",
              padding: "14px 40px",
              borderRadius: "50px",
              fontWeight: 700,
              fontSize: "15px",
              fontFamily: "'Segoe UI', sans-serif",
              boxShadow: "0 8px 24px rgba(255,128,0,0.35)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 30px rgba(255,128,0,0.4)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(255,128,0,0.35)"; }}
          >
            Back to Home
          </Link>
        </div>
      </div>

      <Footer />

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default ApplicationSuccess;
